












import Vue, {PropType} from 'vue'
import { TipoDeNotificacao } from 'src/tipos'

interface Props {
  tipos: TipoDeNotificacao[];
}

export default Vue.extend<{}, {}, {}, Props>({
  name: 'TiposDeNotificacao',

  props: {
    tipos: {
      type: Array as PropType<TipoDeNotificacao[]>,
      required: true
    }
  }
})
